import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGet } from '../hooks/useGet'
import { RadAppLayout } from '../common/RadAppLayout'
import { RadHeader } from '../common/RadHeader'
import { CollectionEditContent } from './CollectionEditContent'

export function CollectionEdit () {
  const { collectionId } = useParams()
  const [formValues, setFormValues] = useState()
  const { data: collection } = useGet(collectionId ? `/api/collection/${collectionId}?include=resources` : null)

  return (
    <RadAppLayout
      contentHeader={
        <RadHeader variant='h1'>
          {collection != null ? 'Edit collection' : 'New collection'}
        </RadHeader>
      }
      content={
        <CollectionEditContent collection={collection} formValues={formValues} setFormValues={setFormValues} />
      }
    />
  )
}
